<template>
  <div
    ref="canvasContainer"
    id="canvas-container"
    class="canvas-container">
    <canvas
      id="engineCanvas"
      class="engine-canvas-box"
      oncontextmenu="event.preventDefault()"
      tabindex="1" />
  </div>
</template>

<script>
import { Store } from '@/utils/store'

export default {
  data() {
    return {}
  },
  mounted() {
    // 增加轮询，防止引擎js文件尚未引入时就调用创建引擎的接口
    const timer = setInterval(() => {
      if (window.CreateBlackHoleWebSDK) {
        this.addEventListener()
        this.initEngine()

        clearInterval(timer)
      }
    }, 500)
  },
  beforeDestroy() {
    this.removeEventListener()
  },
  methods: {
    initEngine() {
      window.BlackHole3D = window.BlackHole3D ? window.BlackHole3D : {}
      window.BlackHole3D.canvas = document.getElementById('engineCanvas')

      if (typeof window.BlackHole3D.RealBIMWeb === 'undefined') {
        window.BlackHole3D = window.CreateBlackHoleWebSDK(window.BlackHole3D)
      }
    },
    addEventListener() {
      document.addEventListener('RESystemReady', this.onSystemReady)
      document.addEventListener('RESystemEngineCreated', this.onCreated)
      document.addEventListener('REDataSetLoadFinish', this.onFinish)
    },
    removeEventListener() {
      document.removeEventListener('RESystemReady', this.onSystemReady)
      document.removeEventListener('RESystemEngineCreated', this.onCreated)
      document.removeEventListener('REDataSetLoadFinish', this.onFinish)
    },
    onSystemReady() {
      const BlackHole3D = window.BlackHole3D
      const engineCanvas = document.getElementById('engineCanvas')
      let sysInfo = new BlackHole3D.RESysInfo()
      sysInfo.workerjsPath = './js/blackhole/RealBIMWeb_Worker.js'
      sysInfo.renderWidth = engineCanvas.parentElement.clientWidth
      sysInfo.renderHieght = engineCanvas.parentElement.clientHeight
      sysInfo.userName = ''
      sysInfo.passWord = ''
      sysInfo.mainWndName = document.title

      if (window.isMinIO) {
        // prettier-ignore
        BlackHole3D.addAuthorPath('RealEngineInitAuthorPath', window.pathCtrlUrlTxt)
        // prettier-ignore
        BlackHole3D.addPathIndex('RealEngineInitPathIndex', window.pathCtrlUrlRes, window.pathCtrlUrlIndex)
      }

      BlackHole3D.initEngineSys(sysInfo)
    },
    onCreated() {
      this.preLoadEngineUIImg()
      this.loadSkyBox()
    },
    loadSkyBox() {
      const BlackHole3D = window.BlackHole3D
      const dataSetList = [
        {
          dataSetId: 'res_skybox',
          resourcesAddress: window.skyBoxUrl
        }
      ]
      BlackHole3D.Model.loadDataSet(dataSetList)

      BlackHole3D.Common.setMaxResMemMB(2000)
      BlackHole3D.Common.setExpectMaxInstMemMB(1900)
      BlackHole3D.Common.setExpectMaxInstDrawFaceNum(20000000)
      BlackHole3D.Common.setPageLoadLev(2)
    },
    onFinish() {
      const engineCanvas = document.getElementById('engineCanvas')
      engineCanvas.classList.add('is-loaded')
    },
    /**
     * 预加载引擎自定义按钮需要的图标
     */
    preLoadEngineUIImg() {
      const Graphics = window.BlackHole3D.Graphics

      const engineUIImgs = Store.engineUIImgs
      engineUIImgs.forEach(item => {
        const lightImgPath = this.getImgPath(item.lightImg)
        const darkImgPath = this.getImgPath(item.darkImg)
        Graphics.setPreLoadPicPath(lightImgPath)
        Graphics.setPreLoadPicPath(darkImgPath)
        if (item.lightCheckImg) {
          const lightCheckImgPath = this.getImgPath(item.lightCheckImg)
          Graphics.setPreLoadPicPath(lightCheckImgPath)
        }
        if (item.darkCheckImg) {
          const darkCheckImgPath = this.getImgPath(item.darkCheckImg)
          Graphics.setPreLoadPicPath(darkCheckImgPath)
        }
      })
    },
    getImgPath(iconName) {
      const { origin, pathname } = window.location
      const iconPath = `${origin}${pathname.split('/index.html')[0]}`
      return `${iconPath}/engineIcon/${iconName}`
    }
  }
}
</script>

<style lang="less" scoped>
.canvas-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: var(--eng-loading-bgColor);
  z-index: -1;

  .engine-canvas-box {
    width: 100%;
    height: 100%;
    outline: none;
    &:focus {
      border: none;
    }
  }
}
</style>
